// extracted by mini-css-extract-plugin
module.exports = {"customers":"FiltersConfig_customers__3hJ0y"};